import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.9504 2.52303C11.2994 2.17408 11.7565 2 12.2136 2C12.6707 2 13.1278 2.17408 13.4768 2.52303C14.174 3.22094 14.174 4.35211 13.4768 5.04938L12.7366 5.78952L10.2103 3.26317L10.9504 2.52303ZM2 11.4734L9.26329 4.21018L11.7897 6.73653L4.52636 13.9998H2V11.4734Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol